module.exports = __webpack_public_path__ + "img/node-generation-transparent.f1a5125d.webp";